import {SCRIPT_RULE} from './constants';
import {gaEvent} from 'js/Core/ga';


export const generateUID = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};

export const isAnyOne = (employee) => _isAnyOne(employee);

export const roundDuration = (duration, block) => _roundDuration(duration, block);

export const storeInfoUser = (person) => {
    let infoData = {},
        storeage = localStorage.getItem('infoData') ? JSON.parse(localStorage.getItem('infoData')) : null;
    if(person && person.id !== ''){
        let {name = '', displayName = '', phone = '' , email = '', birthdate = ''} = person;
        infoData = {
            ...storeage,
            customerName: name !== '' ? name : (storeage && storeage.customerName) ? storeage.customerName : '', 
            fullName: displayName !== '' ? displayName : (storeage && storeage.fullName) ? storeage.fullName : '', 
            phoneNumber: phone !== '' ? phone : (storeage && storeage.phoneNumber) ? storeage.phoneNumber : '', 
            email: email !== '' ? email : (storeage && storeage.email) ? storeage.email : '', 
            birthDate: birthdate !== '' ? birthdate : (storeage && storeage.birthDate) ? storeage.birthDate : ''
        };
        localStorage.setItem('infoData', JSON.stringify(infoData));
    }else{        
        if(storeage){                       
            infoData = storeage;
            localStorage.setItem('infoData', JSON.stringify(infoData));
        }
    }
    return infoData;
}
export const clearInfoUser = () => {
    let infoData = {},
    storeage = localStorage.getItem('infoData') ? JSON.parse(localStorage.getItem('infoData')) : null;
    if(storeage){
        infoData = {
            ...storeage,
            message: '',
            advSelect :'', 
            advFriend: '',
			minTimeOnWeek: '', 
			maxTimeOnWeek: '',
			minTimeWeekend: '',
            maxTimeWeekend: '',
            listShops: '', 
            listRequestItems: [], 
            listOrders: '', 
            listSize: {
				height: '',
				width: '',
				weight: ''
			}
        }
        localStorage.setItem('infoData', JSON.stringify(infoData));
    }
}
export const getQueryVariable = (variable) => {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] == variable){return pair[1];}
    }
    return(false);
}

export const roundTimeLine = (time, block, min = false) => {
    //console.log(time);
    let timeMin = time && time !== 0 ? time.split(":") : time;
    if(timeMin[1] && (parseInt(timeMin[1]) % parseInt(block) > 0)){
        let timeRound = min ? parseInt(timeMin[1]) + (parseInt(timeMin[1]) % block) : parseInt(timeMin[1]) - (parseInt(timeMin[1]) % block),
            timeFirst = timeMin[0];
        if(timeRound === 0){
            timeRound = '00';                
        }
        if(timeRound === 60){
            timeRound = '00';
            timeFirst++;
        }
        timeMin = (timeFirst.length === 1 ? '0' + timeFirst : timeFirst) + ':' + timeRound;
    }else{
        timeMin = time;
    }
    return timeMin;
}

export const compareByOrder = (a,b) => +a.displayOrder - b.displayOrder;

export const countDurationSelected = (list, products) => {
    let result = products.reduce((total, item) => {
        list.forEach(selected => {
            total = selected === item.id ? total + item.duration : total
        });
        return total
    }, 0);
    return result
}

const _isAnyOne=(employee)=>{
    return employee.id==='00000000-0000-0000-0000-000000000000' || employee==='00000000-0000-0000-0000-000000000000';
  };
  
  
const _roundDuration = (duration, block) => {
    let round = duration % block;
    return round > 0 ? ((duration - (duration % block)) + block) : duration;
};
export const getNameTheme = (code) => {
    switch(code){
        case 'FUKADA': return 'Fukada';
        case 'VACANCE': return 'Vacance';
        case 'YURIKAGO': return 'Yurikago';
        case 'SBS_VIEW': return 'SBS';
        case 'STEP_VIEW':
        default : return 'Step';
    }
}

const parseStringToListScript = (str) => {
    let regex = SCRIPT_RULE.DETECT_SCRIPT,
        regexWhiteSpace = SCRIPT_RULE.WHITE_SPACE,
        strTrim = str.replace(regexWhiteSpace, ''),
        result = strTrim.match(regex);
    return result;
}

const createInlineJs = (str) => {
    let scriptPush = document.createElement('script');                      
    scriptPush.type ="text/javascript";
    scriptPush.text = str;

    return scriptPush;
         
}

const loadAllScript = (listUrl, urlRedirect = '', apptId, appName) => {
    let promises = [];
    listUrl.forEach(item => {
        promises.push(loadScriptAsync(item))
    });
    Promise.all(promises).then(res => {
        gaEvent(appName, 'Load SEO scripts', 'Successfully/'+apptId);
        if(urlRedirect !== '') window.location.href = urlRedirect;
    }).catch(err => {
        gaEvent(appName, 'Load SEO scripts', 'Failed/'+apptId);
        if(urlRedirect !== ''){
            window.location.href = urlRedirect;
        }
    })
}
const loadScriptAsync = function(uri){
    let bodyEl = document.getElementsByTagName('body')[0];
    return new Promise((resolve, reject) => {
        var tag = document.createElement('script');
        tag.src = uri;
        tag.async = true;
        tag.onload = () => {
            resolve();
        };
        tag.onerror = () => {
            reject('Error');
        }
        bodyEl.appendChild(tag); 
    });  
    
}
export const importLibJs = (str, apptId, appName, urlRedirect = '') => {   
    if(str === '') return;
     
    let strParse = parseStringToListScript(str);
    let regexDetect = SCRIPT_RULE.DETECT_SRC_SCRIPT,
        regexGet = SCRIPT_RULE.SRC_SCRIPT,
        regexContent = SCRIPT_RULE.CONTENT_SCRIPT,
        bodyEl = document.getElementsByTagName('body')[0],
        listUrl = [];
    try{
        strParse.forEach(item => {
            let result = item.match(regexDetect),
                tagScript;
            if(result){            
                let url = result[0].split(regexGet);
                listUrl.push(url[1]);
            }else{
                let content = item.split(regexContent);
                tagScript = createInlineJs(content[1]);
                bodyEl.appendChild(tagScript); 
            }        
        })
        loadAllScript(listUrl, urlRedirect, apptId, appName)
    }catch(err){
        return err;
    }
}

export const isOutViewPort = (el) => {
    let elOffset = el.getBoundingClientRect(),
        offsetTop = elOffset.top,
        offsetBottom = elOffset.bottom;	
    if(offsetTop < 0) return true;
    if(offsetBottom > (window.innerHeight || document.documentElement.clientHeight)) return true;
    return false
}

export const checkProductsIsValid = (selectedProducts, listProducts, listProductsEmp, listProductsResource) => {
    let checkShow = checkProductIsShow(selectedProducts), // check if product(s) display and not delete
        checkHasProduct = checkItemWithList(selectedProducts, listProducts), // check if list products has this product(s)
        checkWithEmp = checkItemWithList(selectedProducts, listProductsEmp, 'productId'); // check if product(s) has a relationship with employee
        //checkWithResource = checkItemWithList(selectedProducts, listProductsResource, 'productId'); // check if product(s) has a relationship with resource


    return checkShow && checkHasProduct && checkWithEmp ;//&& checkWithResource;
}

const checkProductIsShow = (selectedProducts) => {
    let check = true;
    selectedProducts.forEach(item => {
        if(!item.display || item.delete) check = false;
    })
    return check;
}
const checkItemWithList = (items, list, id = 'id') => {
    let timeValid = 0;
    items.forEach(item => {
        let checkProduct = list.some(p => p[id] === item.id);
        if(checkProduct) timeValid++;
    })
    return timeValid === items.length;
}

export const checkEmployeeIsValid = (selectedEmployee, list, shop, listEmployeeProducts) => {
    //if(!shop.allowRequestStaff && !_isAnyOne(selectedEmployee)) return {status: false, isAnyOne: true};
    if(!selectedEmployee) return {status: false, isAnyOne: false};
    if(_isAnyOne(selectedEmployee)) return {status: false, isAnyOne: true};
    //if(shop.hideAnyOne && _isAnyOne(selectedEmployee)) return false;
    if(!selectedEmployee.display) return {status: false, isAnyOne: false};
    let checkEmp = list.some(p => p.id === selectedEmployee.id),
        checkEmpProducts = listEmployeeProducts.some(p => p.employeeId === selectedEmployee.id);
    return {status: checkEmp && checkEmpProducts, isAnyOne: false};
}